import Vue from 'vue';
import PageState from './store/state';
import { Toast,Dialog } from "vant"; 
import Cookies from 'js-cookie'
import Component from 'vue-class-component';
import { isWeiXin } from "@/utils/open-download-app";
import LZString from '../../utils/lz-string.min'
import moduleStore from './store/recallPay'
const util = require('@/bin/util.js');
import Clipboard from 'clipboard'
import openAppByBtn from '../../utils/open-download-app'
import PayCard from '../../components/pay/pay.vue'
import { customCollectEvent } from '@/utils/collect'
@Component({
    components: {
        PayCard
    },
})

@moduleStore.initVuex({
    mutationNames: moduleStore.mutationNames,
    actionNames: moduleStore.actionNames,
})
export default class recallPage extends Vue implements IvuePage<PageState>{
    self:Vue = this;
    state = new PageState();
    phoneNumber:any='';
    payType: number = 0;//支付方式 0 微信   1支付宝
    activationType: string = 'now';//激活方式 now 立即激活    later 预约激活
    dataPoupShow: boolean = false;//是否显示底部弹窗
    currentDate: Date = new Date();//激活日期
    minDate: Date = new Date(2024, 0, 1) // 
    maxDate: Date = new Date(2035, 0, 1) // 明确类型
    startTime:string='';//激活时间
    customerService:boolean= false;//是否显示联系客服弹窗
    payLoading:boolean= false; //是否显示支付中弹窗
    paySuccess: boolean= false; //是否显示支付成功弹窗
    paramsData:any={};// 购买参数
    packageInfo:any={};// 套餐信息
    memberRightsDesc: Array<any>=[];//会员权益描述
    speakerDescription: Array<any>=[];// 声音包权益描述	
    orderInfo:any={
        orderId:'',
        businessType:''
    };// 订单信息
    jsCode:string='';// 微信支付需要
    paySuccessDesc:string='';// 支付成功描述
    timer: NodeJS.Timeout;// 轮询定时器
    recentPaidList: Array<any> = []; // 最近支付列表
    selected:number=0;
    buyNow: Boolean = false;
    created(moduleData:IinjectDatas){
        this.state = <PageState>moduleData.state;
        this.buyNow=isWeiXin()
        if(isWeiXin()){
            Dialog.confirm({
                message:'请到其他浏览器进行购买',
                showConfirmButton:false,
                cancelButtonText:'确认',
                className: 'recall-dialog',
            })
        }
        customCollectEvent('h5_mkt_moyunxi_exposure')
        this.$http('getPackageInfo').then(res=>{
            let {code , data , message} = res;
            if(code==200){
                this.packageInfo = data.memberPackageList[0].packageInfo;
                this.memberRightsDesc = data.memberPackageList[0].vipDescription;
                this.speakerDescription = data.memberPackageList[0].speakerDescription	;
            }else{
                Toast({
                    message: message,
                    icon: "none",
                    duration: 3000,
                    position: 'top',
                })
            }
        }).catch(err=>{
            console.log(err)
        })
        this.$http('getRecentOrder').then(res=>{
            let {code , data , message} = res;
            if(code==200){
                this.recentPaidList = data;
            }else{
                Toast({
                    message: message,
                    icon: "none",
                    duration: 3000,
                    position: 'top',
                })
            }
        }).catch(err=>{
            console.log(err)
        })
    }
    onPageShow(event) {
        if (event.persisted) {
          // from back-forward cache
          this.checkOrderStatus();
        }
    }
    beforeDestroy() {
      window.removeEventListener('pageshow', this.onPageShow)
    }
    mounted() {   
        window.addEventListener('pageshow', this.onPageShow)    
        console.log('测试跳转')
        this.checkOrderStatus()
    }
    checkOrderStatus(){
        clearInterval(this.timer)
        let orderInfo= JSON.parse(localStorage.getItem('orderInfo2') || '{}')
        if(! orderInfo.orderId) return
        if(Date.now()-orderInfo.orderTimeDate>4*60*1000){
            localStorage.removeItem('orderInfo2')
            return
        }
        //显示支付中弹框
        this.payLoading=true
        this.orderInfo ={
            orderId: orderInfo.orderId,
            businessType: orderInfo.businessType
        };
        // 轮询支付状态
        this.timer = setInterval(() => {  
            this.payStatus();
        }, 3000); 
    }
    payLoadingClose(){
        clearInterval(this.timer)
        localStorage.removeItem('orderInfo2')
        this.payLoading=false
    }
    phoneChange(){
        //超过11位
        if(this.phoneNumber.length>11){
            this.phoneNumber = this.phoneNumber.slice(0,11)
        }
        console.log(this.phoneNumber)
    }
    // 确认激活时间
    confirm(value:Date){
        //判断当前年月日是否小于今天
        let now = util.dateFormate(new Date(), "yyyy-MM-dd")
        let startTime = util.dateFormate(value, "yyyy-MM-dd");
        // 将时间转换为时间戳
        let startTimeStamp = new Date(startTime).getTime();
        let nowStamp = new Date(now).getTime();
        if(startTimeStamp<nowStamp){
            Toast({
                message: "激活时间不能小于当前时间",
                icon: "none",
                duration: 3000,
                position: 'top',
            })
            return;
        }
        this.startTime = startTime
        this.dataPoupShow = false;
    }
    // 提交
    async submit(){
        if(this.activationType==='later' && this.startTime===''){
            Toast({
                message: "请选择激活时间",
                icon: "none",
                position: 'top',
            })
            return;
        }
        const myreg = /^[1][0-9]{10}$/;
        if (!myreg.test(this.phoneNumber)) {
			Toast({
                message: "请输入正确的手机号",
                icon: "none",
			    position: 'top',
            })
            return;
        
        }
        //创建订单
        let params = {
            packageId:this.packageInfo.id, // 套餐包id
            phone:this.phoneNumber, // 手机号
            date: this.activationType=='now'? '' : this.startTime, // 激活时间
            payType:this.payType, // 0 微信    1 支付宝
            jsCode: this.jsCode,//微信支付需要
        }
        // 创建订单
        this.$http('createOrder',params).then(res=>{
            if(res.code==200){
                let localData={
                    ...res.data,
                    orderTimeDate: Date.now()
                }
                //将订单信息存储在本地
                localStorage.setItem('orderInfo2',JSON.stringify(localData))
                this.orderInfo ={
                    orderId:res.data.orderId,
                    businessType:res.data.businessType
                };
                this.h5Pay(this.payType,res.data,{path:'/recall',query:{status:'payLoading'}})
            }else{
                Toast({
                    message: res.message,
                    icon: "none",
                    duration: 3000,
                    position: 'top',
                })
            }
        }).catch(err=>{
            Toast({
                message: err.message,
                icon: "none",
                duration: 3000,
                position: 'top',
            })
            console.log(err)
        })
    }
    // 刷新支付状态
    refreshPayStatus(){
        console.log('刷新支付')
        // this.payStatus()
    }
    // 轮训支付状态
    payStatus(){
        console.log('dddddddd')
        let orderInfo= JSON.parse(localStorage.getItem('orderInfo2') || '{}')
        if(Date.now()-orderInfo.orderTimeDate>4*60*1000){
            this.payLoading=false
            localStorage.removeItem('orderInfo2')
            clearInterval(this.timer)
            Toast({
                message: "未支付",
                icon: "error",
                duration: 2000,
                position: 'top'
            })
            return
        }
        this.$http('queryOrderStatus',this.orderInfo).then(res=>{
            if(res.code==200){
                if(res.data.orderStatus!==0){
                    this.payLoading=false
                    clearInterval(this.timer)
                    //删除本地存储
                    localStorage.removeItem('orderInfo2')
                }
                if(res.data.orderStatus==1){
                    this.activationType = res.data.type==0?'now':'later';
                    //预约激活描述
                    this.paySuccessDesc = `恭 喜 您 支 付 成 功  ， 您 的 账 号 ${res.data.phone}已成功预约一年会员 +魔云熙权益，权益生效时间：${res.data.date}，您可截图保存作为权益凭证`;
                    this.paySuccess = true;
                }
            }else{
                //清除定时器
                clearInterval(this.timer)
                this.payLoading=false
                Toast({
                    message: "服务器错误",
                    icon: "error",
                    duration: 2000,
                    position: 'top'
                })
            }
        }).catch(err=>{
            this.payLoading=false
            Toast({
                message: "服务器错误",
                icon: "error",
                duration: 2000,
                position: 'top'
            })
            //清除定时器
            clearInterval(this.timer)
            console.log(err)
        })
    }
    /**h5支付-在普通浏览器中打开 */
    h5Pay(payTypeIndx,payInfo: any, succObj?: any) {
        let infoCompress = LZString.compressToBase64(JSON.stringify({
              ...payInfo,
          }))
          console.log('---H5支付infoCompress',infoCompress)
          let payType ='';
          payType = payTypeIndx===1?'alipayH5':'wxpayH5';
          this.$router.push({
          path: '/middlePageOfPay',
            query: {
                info: infoCompress,
                // from: 'recallSuccess',
                payType:payType,
                desc:''
            },
          });
      }
    // 去魔音小程序
    goToMiniProgram(){
        window.location.href = '/turnToMember.html?type=recall'
    }
    goToApp(){
        openAppByBtn()
            this.$nextTick(() => {
                // app
                const clipboardApp = new Clipboard('#moyin-app', {
                    text: () => 'https://mobvoi-backend-public.ticwear.com/moyin/apk/moyin_release_official_23.2.3_20220505.apk'
                });
                clipboardApp.on('success', function() {
                    Toast({
                        message: "已复制APP下载地址，请前往浏览器中打开进行下载使用",
                        icon: "success",
                        duration: 2000,
                        position: 'top'
                    })
                })
            })
    }
}
